export default {
  breakdown: {
    label: 'Show breakdown of',
    placeholder: '',
    system: {
      name: 'breakdown',
    },
    value: '',
    type: 'select',
    source: [
      {
        value: 1,
        text: 'Assignments',
      },
      {
        value: 2,
        text: 'Task Difficulty',
      },
    ],
  },
  card_type: {
    label: 'Card Type',
    placeholder: '',
    system: {
      name: 'card_type',
    },
    value: '',
    type: 'select',
  },
  in_stage: {
    label: 'In Stage',
    placeholder: '',
    system: {
      name: 'stage',
    },
    name: 'stage',
    value: '',
    type: 'select',
  },
  in_project: {
    label: 'In Project',
    placeholder: '',
    system: {
      name: 'project',
    },
    value: '',
    type: 'select',
    rules: {}
  }
}



// WEBPACK FOOTER //
// ./src/containers/Analytics/fields.js